/**
 * Created by tofael on 9/3/18.
 */

import React from 'react';
import PdfViewer from './pdf-viewer';
import Dialog from 'material-ui/Dialog';
import ImageViewer from './image-viewer';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import SelectField from 'material-ui/SelectField';
import config from '../../../../utility/app-config';

const styles = {
  root: {

  },
  customContentStyle: {
    width: '100%',
    height: '100%',
    maxWidth: 'none',
    maxHeight: 'none'
  },
  container: {

  },
  box: {
    width : '100%',
    height: '770px'
  },
  button: {
    height: '45px',
    width: '200px'
  },
  select: {
    width: '35%',
    color: '#000000'
  },
};

const formatFileUrl =(file)=> {
  if (typeof file === 'string' || file instanceof String){
    return `${config.urls.doc_url}${file}`;
  }
  return file;
};

const DocumentPreview = ({selectedFiles, file, fileType, showPreview,  onSelectReportType, selectedReportType, onRequestClose, onSubmit, reportTypes}) => {
  const actions = [
    <FlatButton
      label="Close"
      primary={true}
      style={styles.button}
      onTouchTap={onRequestClose} />
  ];
  if(onSubmit && Array.from(selectedFiles).length > 0) {
    actions.push(
      <FlatButton
        label="Submit"
        primary={true}
        style={styles.button}
        onTouchTap={onSubmit.bind(null, selectedFiles, selectedReportType)} />
    );
  }

  return (
      <Dialog
        modal={false}
        open={showPreview}
        actions={actions}
        autoScrollBodyContent={true}
        onRequestClose={onRequestClose}
         >
          { reportTypes && 
             <SelectField
                floatingLabelText="Select A Report Type"
                style={styles.select}
                value={selectedReportType}
                onChange={onSelectReportType}
                  >
                {
                  reportTypes
                  .map(d => 
                    <MenuItem 
                    primaryText={d}
                    key={d.id}
                    value={d}/>
                  )
                }
            </SelectField>
          }
          { selectedFiles ? (Array.from(selectedFiles).map((file) => (
            <div style={styles.box}>
                {
                 file.type.split('/')[0] === 'image' && <ImageViewer file={formatFileUrl(file)}/>
                }
                {
                 file.type.split('/')[1] === 'pdf' && <PdfViewer file={formatFileUrl(file)} />
                }
            </div>
               ))) : (
                <div style={styles.box}>
                {
                 fileType && fileType.split('/')[0] === 'image' && <ImageViewer file={formatFileUrl(file)}/>
                }
                {
                 fileType && fileType.split('/')[1] === 'pdf' && <PdfViewer file={formatFileUrl(file)}/>
                }
                </div> 
            )}
      </Dialog>
  );
};

export default DocumentPreview;


// WEBPACK FOOTER //
// ./src/screens/shared/file-upload/preview/index.js